module.exports = __webpack_public_path__ + "img/flag_of_russia.cecd6645.svg";